// Styles
import styles from './styles/index.module.scss'
// Packages
import { useContext, useState, useEffect, useMemo } from 'react';
import { 
  BiSearch,
  BiAddToQueue,
  BiBlock,
  BiArrowBack
} from 'react-icons/bi'
import { w3cwebsocket as WebSocket } from "websocket";
import { MoonLoader } from 'react-spinners';
import { motion } from "framer-motion"
import { useNavigate } from 'react-router-dom';
import { MdQueueMusic } from 'react-icons/md'
// Import files
import { PlayerContext } from '../../../utils/contexts/PlayerContext';
import { useFetchPlayerGuild } from "../../../utils/hooks/useFetchPlayerGuild"
import { Spinner } from '../../../components/misc/Spinner'
import useWindowDimensions from '../../../utils/hooks/useWindowDimensions'
import MobilePanel from "./Layout/Mobile"
import Sidebar from "./Layout/Sidebar"
import MobileSidebar from "./Layout/MobileSidebar"
import Panel from "./Layout/Panel"
import data from '../../../data/config.json'

const MenuPage = ({ user }: any) => {
  const navigate = useNavigate();
  const { playerGuild, updatePlayerGuild } = useContext(PlayerContext);
  const { guilds, loading } = useFetchPlayerGuild();
  const { width } = useWindowDimensions();
  const youtube_regex = /(?:https?:\/\/)?(?:www\.)?youtu(?:\.be\/|be.com\/\S*(?:watch|embed)(?:(?:(?=\/[-a-zA-Z0-9_]{11,}(?!\S))\/)|(?:\S*v=|v\/)))([-a-zA-Z0-9_]{11,})/

  if (width <= 1100) document.body.style.backgroundColor = "black"
  else if (width > 1100) document.body.style.backgroundColor = "#1d1d1d"

  const client = useMemo(() => new WebSocket(data.websocket), []);

  // Player state
  const [pause, setPause] = useState(true)
  const [loop_status, setLoop] = useState("none")
  const [current, setCurrent] = useState<any>()
  const [res, setRes] = useState<any>()
  const [searchLoad, setSearchLoad] = useState(false)
  const [queue, setQueue] = useState<any>()
  const [member, setMember] = useState(false)
  const [choose, setChoose] = useState<any>([])
  const [viewtab, setViewTab] = useState("queue")

  useEffect(
    () => {
      client.onopen = () => {
        console.log('WebSocket Client Connected');
        setLoop("none")
        client.send(JSON.stringify({ message: "status", guild: playerGuild?.id, user: user?.id }))
        client.send(JSON.stringify({ message: "member_status", guild: playerGuild?.id, user: user?.id }))
      };
    
      client.onmessage = (message) => {
        const json = JSON.parse(message.data.toString())
        console.log(json);
        if (playerGuild?.id !== json.guild) {
          setMember(false)
          setRes(undefined)
          setPause(true)
          setCurrent(undefined)
          setQueue(undefined)
          setChoose(undefined)
          return setLoop("none")
        }
        if (json.op === `player_destroy`) {
          setRes(undefined)
          setPause(true)
          setCurrent(undefined)
          setQueue(undefined)
          return setLoop("none")
        }
        if (json.op === `pause_track`) return setPause(true)
        if (json.op === `player_start`) {
          setPause(false)
          setCurrent(json.current)
          json.current && queue && loop_status && loop_status === "track" ? queue.push(json.current) : setPause(false)
          return
        }
        if (json.op === `resume_track`) return setPause(false)
        if (json.op === `loop_queue`) return setLoop(json.status)
        if (json.op === `search`){
          setSearchLoad(false)
          return setRes(json.queue)
        } 
        if (json.op === `voice_state_update_join`) return setMember(true)
        if (json.op === `voice_state_update_leave`){
          setRes(undefined)
          return setMember(false)
        }
        if (json.op === "player_queue") {
          setQueue(json.queue)
          return
        }
        if (json.op === "player_end" && queue){
          const index = queue.map((e: any) => e.uri).indexOf(json.track.uri);
          queue.splice(index, 1);
          return 
        }
        if (json.op === "removed_track" && queue) {
          client.send(JSON.stringify({ message: "queue", guild: playerGuild?.id }))
          return 
        }
        if (json.op === "previous_track" && queue) {
          queue.unshift(json.track)
          return 
        }
        if (json.op === "status" && loop_status) {
          setMember(json.member)
          setPause(json.pause)
          setCurrent(json.current ? json.current : undefined)
          setQueue(json.queue && json.queue.length !== 0 ? json.queue : undefined)
          if (json.queue.length === 0 && json.current) setQueue([json.current])
          setLoop(json.loop)
        }
      };
    
      client.onclose = () => {
        setMember(false)
        setRes(undefined)
        setPause(true)
        setCurrent(undefined)
        setLoop("none")
        setQueue(undefined)
        setChoose(undefined)
        navigate('/player/select')
      }
    },
    [client, playerGuild, navigate, user, queue, loop_status]
  )

  if (loading) return <Spinner children={<MoonLoader size={40} color="white" />} />;

  async function sendTracks(track: any) {
    setChoose(() => [track.uri])
    if (choose && choose.includes(track.uri)) return
    await client.send(JSON.stringify({ message: "add", guild: playerGuild?.id, user: user?.id, tracks: [track]  }))
    await queue.push(...track)
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const query = e.target.search.value
    const source = e.target.source.value
    if (youtube_regex.test(query)) return
    setSearchLoad(true)
    setRes(undefined)
    setChoose(undefined)
    await client.send(JSON.stringify({ message: "search", guild: playerGuild?.id, query: query, source: source }))
  };

  async function removeClick(track: any) {
    await client.send(JSON.stringify({ message: "remove", guild: playerGuild?.id, uri: track.uri }))
  }

  async function removeAllClick() {
    await client.send(JSON.stringify({ message: "destroy", guild: playerGuild?.id }))
  }

  function removeAllSearchClick() {
    setRes(undefined)
    setChoose(undefined)
  }

  function copyText(title: string) {
    navigator.clipboard.writeText(title);
  }

  function setTab(location: string) {
    client.send(JSON.stringify({ message: "member_status", guild: playerGuild?.id, user: user?.id }))
    if (location === "queue") {
      setViewTab("queue")
      client.send(JSON.stringify({ message: "queue", guild: playerGuild?.id }))
      return
    }
    if (location === "search") {
      setViewTab("search")
      return
    }
  }

  // Player control panel
  return (
    <div>
      <MobilePanel 
        client={client} 
        playerGuild={playerGuild} 
        current={current} 
        pause={pause} 
        loop={loop_status}
        res={res}
        member={member}
        user={user}
        queue={queue}
        setRes={setRes}
        setChoose={setChoose}
        choose={choose}
      />

      <Sidebar 
        client={client} 
        guilds={guilds} 
        playerGuild={playerGuild} 
        updatePlayerGuild={updatePlayerGuild} 
        user={user}
      />

      <div>
        <div className={styles.panel}>
          <div className={styles.sidebar}>
            <motion.div whileTap={{ scale: 0.9 }} className={styles.sidebar_button_space} title="Back to select menu">
              <div className={styles.sidebar_button} onClick={() => navigate("/player/select")}>
                <BiArrowBack color="#ffffff" size={50}/>
              </div>
            </motion.div>

            <motion.div whileTap={{ scale: 0.9 }} className={styles.sidebar_button_space} title="Queue">
              <div className={styles.sidebar_button} onClick={() => setTab("queue")}>
                <BiAddToQueue color="#ffffff" size={50}/>
              </div>
            </motion.div>

            <motion.div whileTap={{ scale: 0.9 }} className={styles.sidebar_button_space} title="Search">
              <div className={styles.sidebar_button} onClick={() => setTab("search")}>
                <BiSearch color="#ffffff" size={50}/>
              </div>
            </motion.div>

          </div>

          <div className={styles.queue} data-state={viewtab === "queue" ? "true" : "false"}>

            <div className={styles.mem} data-state={member ? "true" : "false"}>

              {
                queue ? (
                  <div className={styles.queue_res} data-state={queue ? "true" : "false"}>
                    <div className={styles.queue_remove_all} onClick={() => removeAllClick()}>
                      <p>Remove all tracks in queue</p>
                    </div>
                  {
                    queue && queue.map((t: any, index: any) => (
                      <div 
                        key={!t.uri ? "https://www.y.com/watch?v=dQw4w9WgXcQ" : t.uri} 
                        className={styles.queue_tab} 
                        data-number={index % 2 === 0 ? "even" : "odd"} 
                        data-color={current && t.uri && t.uri === current.uri ? "true" : "false"}>

                        <div className={styles.queue_info}>
                          <motion.div whileTap={{ scale: 0.99 }} className={styles.queue_title} onClick={() => copyText(t.title || "")}>
                            <p>{`${index + 1}. ` + t.title || "Notting"}</p>
                          </motion.div>

                          <div className={styles.flex_button}>

                            <motion.div whileTap={{ scale: 0.99 }} className={styles.queue_button} onClick={() => removeClick(t)} title="Remove track from queue">
                              <BiBlock size={40} color="#ffffff" />
                            </motion.div>

                            {t.uri === current.uri ? (
                              <motion.img 
                              src='/no_music.png'  
                              alt={t.title}
                              animate={{
                                rotate: 360,
                              }}
                              transition={{ ease: "linear", duration: 20, repeat: Infinity }}/>
                            ) : (
                              <img src='/no_music.png' alt={t.title}/>
                            )}

                          </div>

                        </div>

                      </div>
                    ))
                  }

                </div>
                ) : <></>
              }

              <div className={styles.queue_none} data-state={queue ? "true" : "false"}>
                <BiAddToQueue size={90} color="#ffffff"/>
                <p>No song in queue! Search a song and add to your player queue!</p>
              </div>

            </div>

            <div className={styles.queue_no_mem} data-state={!member ? "true" : "false"}>
              <MdQueueMusic size={90} color="#ffffff"/>
              <p>To use this feature, you need to enter the voice channel first.</p>
            </div>

          </div>

          <div className={styles.search} data-state={viewtab === "search" ? "true" : "false"}>

            <div className={styles.mem} data-state={member ? "true" : "false"}>
              <form className={styles.search_panel} onSubmit={handleSubmit}>
                <select form-name="source" name="source">
                  <option value="soundcloud" selected={false}>
                    SoundCloud
                  </option>
                  <option value="spotify" selected={true}>
                    Spotify
                  </option>
                  <option value="nicovideo" selected={true}>
                    NicoVideo
                  </option>
                  <option value="deezer" selected={true}>
                    Deezer
                  </option>
                </select>
                <input form-name="search" type="text" name="search" placeholder="Type here to search!" autoComplete="off"/>
                <input form-name="summit" className={styles.search_input} type="submit" value="Search"/>
              </form>

              <div className={styles.search_res} data-state={res ? "true" : "false"}>

                <div className={styles.search_remove_all} onClick={() => removeAllSearchClick()}>
                  <p>Remove all tracks in search</p>
                </div>
                {
                  res && res.map((t: any) => (
                    <motion.div 
                      whileTap={{ scale: 0.98 }} 
                      key={t.uri} 
                      className={styles.search_choose} 
                      onClick={() => sendTracks(t)} 
                      data-selected={choose ? choose.includes(t.uri) ? "true" : "false" : "false"}>
                      <p>{t.title}</p>
                      <img src='/no_music.png' alt={t.title}/>
                    </motion.div>
                  ))
                }
              </div>


              {
                searchLoad ? <Spinner children={<MoonLoader size={40} color="white" />} />
                : (
                  <div className={styles.search_none} data-state={res ? "true" : "false"}>
                    <BiSearch size={90} color="#ffffff"/>
                    <p>To search for music, type in the search box and press Search</p>
                  </div>
                )
              }

            </div>

            <div className={styles.no_mem} data-state={!member ? "true" : "false"}>
              <BiSearch size={90} color="#ffffff"/>
              <p>To use this feature, you need to enter the voice channel first.</p>
            </div>

          </div>


        </div>

      </div>

      <Panel 
        client={client} 
        playerGuild={playerGuild} 
        current={current} 
        pause={pause} 
        loop={loop_status}
        res={res}
        member={member}
        user={user}
        queue={queue}
      />

      <MobileSidebar 
        client={client} 
        guilds={guilds} 
        playerGuild={playerGuild} 
        updatePlayerGuild={updatePlayerGuild}
        user={user}
      />
    </div>
  )
}

export default MenuPage